import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useSaveDrugQuote = () => {
    const { mutate: saveDrugQuote, isLoading } = useMutation(
        async (payload) => {
            const dataToSend = Array.isArray(payload) ? payload : [payload];
            const response = await SrxApi.post('/drugsearch/savequote', dataToSend);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message =
                    data?.message ?? data?.data?.message ?? 'Drug quote saved successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to save drug quote';
                toast.error(errorMessage);
            },
        }
    );

    return {
        saveDrugQuote,
        isSaveDrugQuoteLoading: isLoading,
    };
};

export default useSaveDrugQuote;
